"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VideoCameraControlOutlineNo = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_VideoCameraControlOutlineNo_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 16,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.576 3.825a.752.752 0 0 0-.776.074l-2.6 1.944a.501.501 0 0 0 .6.8L15 5v6.002l-2.2-1.644a.5.5 0 0 0-.6.8l2.6 1.944a.752.752 0 0 0 1.2-.6V4.499c0-.351-.22-.58-.424-.674ZM6.5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM5.854 4.646a.5.5 0 0 0-.708 0l-.9.9a.5.5 0 1 0 .708.708l.546-.547.546.547a.5.5 0 1 0 .708-.708l-.9-.9ZM3.754 7.454a.5.5 0 1 0-.708-.708l-.9.9a.5.5 0 0 0 0 .708l.9.9a.5.5 0 1 0 .708-.708L3.207 8l.547-.546ZM7.954 6.746a.5.5 0 1 0-.708.708L7.793 8l-.547.546a.5.5 0 1 0 .708.708l.9-.9a.5.5 0 0 0 0-.708l-.9-.9ZM6.754 10.454a.5.5 0 0 0-.708-.708l-.546.547-.546-.547a.5.5 0 1 0-.708.708l.9.9a.5.5 0 0 0 .708 0l.9-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3H1.5A1.5 1.5 0 0 0 0 4.5V10a3 3 0 0 0 3 3h6.5a1.5 1.5 0 0 0 1.5-1.5V6a3 3 0 0 0-3-3Zm0 1c1.103 0 2 .897 2 2v5.5a.5.5 0 0 1-.5.5H3c-1.103 0-2-.897-2-2V4.5a.5.5 0 0 1 .5-.5H8Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_VideoCameraControlOutlineNo_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = VideoCameraControlOutlineNo;
exports["default"] = _default;